import {Selector, State} from "@ngxs/store";
import {ReportDevicesTabStateModel} from "@store/report/devices/devices.model";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {IResponse} from "@interfaces/response";
import {IDevice} from "@interfaces/devices";
import {DeviceService} from "@services/device/device.service";
import {tap} from "rxjs/operators";
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

@StateRepository()
@State<ReportDevicesTabStateModel>({
    name: 'reportDevicesTab',
    defaults: {
        devices: [],
        loader: false,
        currentPage: 1,
        itemsPerPage: 6,
        search: '',
        totalDevices: 0,
        order: ''
    }
})

@Injectable()
export class ReportDevicesTabState extends NgxsDataRepository<ReportDevicesTabStateModel> {
    constructor(private deviceService: DeviceService) {
        super();
    }

    @Selector([ReportDevicesTabState])
    static getSearch(state: ReportDevicesTabStateModel): string {
        return state.search;
    }

    @DataActionWithoutSubscription({cancelUncompleted: true})
    fetchDevices(): Observable<IResponse<IDevice>> {
        const limit = this.ctx.getState().itemsPerPage;
        const skip = limit * (this.ctx.getState().currentPage - 1);
        const search = this.ctx.getState().search;
        const order = this.ctx.getState().order

        this.ctx.patchState({loader: true})
        return this.deviceService.getDevices({limit, search, skip, order})
            .pipe(
                tap((data) => {
                    const state = this.ctx.getState();
                    this.ctx.setState({...state, devices: data.rows, totalDevices: data.total, loader: false})
                })
            )
    }

    @DataActionWithoutSubscription()
    searchDevices(@Payload('[Report devices] search devices') search: string): void {
        this.ctx.patchState({search, currentPage: 1})
    }

    @DataActionWithoutSubscription()
    getDevicesByPage(@Payload('[Report devices] get devices by page') page: number): Observable<any> {
        this.ctx.patchState({currentPage: page})
        return this.fetchDevices();
    }

    @DataActionWithoutSubscription()
    sortDevices(@Payload('[Report devices] sort devices') order: string): Observable<any> {
        this.ctx.patchState({order})
        return this.fetchDevices();
    }
}
